import {
    createStore,
    applyMiddleware,
    combineReducers,
    compose,
} from 'redux';
import { all } from 'redux-saga/effects';
import createSagaMiddleware from 'redux-saga';

//Reducers
import bookingReducer from './reducers/booking';
import companiesReducer from './reducers/companies';
import paymentReducer from './reducers/payment';
import authReducer from './reducers/auth';
import uiReducer from './reducers/ui';
import reservationsReducer from './reducers/reservations';
import bundlesReducer from './reducers/bundles';
import profileReducer from './reducers/profile';
import localesReducer from './reducers/locales';
import eventsReducer from './reducers/events';
import groupsReducer from './reducers/groups';
import widgetReducer from './reducers/widget';
import subscriptionsReducer from './reducers/subscriptions'
import { healthReducer } from './reducers/health';

//Sagas
import { watchAuth } from './sagas/auth';
import { watchCompanies } from './sagas/companies';
import { watchBooking } from './sagas/booking';
import { watchPayment } from './sagas/payment';
import { watchBundles } from './sagas/bundles';
import { watchReservations } from './sagas/reservations';
import { watchProfile } from './sagas/profile';
import { watchLocales } from './sagas/locales';
import { watchEvents } from './sagas/events';
import { watchGroups } from './sagas/groups';
import { watchWebSocket } from './sagas/websocket';
import { watchWidget } from './sagas/widget';
import { watchSubscriptions } from './sagas/subscriptions';
import { watchHealth } from './sagas/health';

const rootReducer = combineReducers({
    companies: companiesReducer,
    booking: bookingReducer,
    payment: paymentReducer,
    auth: authReducer,
    ui: uiReducer,
    bundles: bundlesReducer,
    reservations: reservationsReducer,
    profile: profileReducer,
    locales: localesReducer,
    events: eventsReducer,
    groups: groupsReducer,
    widget: widgetReducer,
    subscriptions: subscriptionsReducer,
    health: healthReducer,
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middleware = [
    sagaMiddleware
];

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleware))
);

export default store;

function* rootSaga() {
    yield all([
        ...watchAuth,
        ...watchCompanies,
        ...watchBooking,
        ...watchPayment,
        ...watchBundles,
        ...watchReservations,
        ...watchProfile,
        ...watchLocales,
        ...watchEvents,
        ...watchGroups,
        ...watchWebSocket,
        ...watchWidget,
        ...watchSubscriptions,
        ...watchHealth,
    ]);
}


sagaMiddleware.run(rootSaga);



